import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router";
import api from './Services';
import { ChevronRight,ChevronLeft, Trash2, Edit, X, Plus, CircleX, Clock, LoaderCircle} from 'lucide-react';
import SelectProjects from './SelectProjects';
import SelectClients from './SelectClients';
import SelectClientsProjects from './SelectClientsProjects';

export default function Timesheet(props) {

//GLOBAL
  const API_URL = 'https://projects.ckellycreative.com/api/wp-json';
  const navigate = useNavigate();
  const currDate = new Date(); // get current date
  const currYear = currDate.getFullYear(); 
  const currMonth = currDate.getMonth() + 1; 
  const currDay = currDate.getDate(); 
  let currHours = currDate.getHours().toString().padStart(2, 0); // get current hours
  let currMinutes = currDate.getMinutes().toString().padStart(2, 0); // get current min
  const currTime = `${currHours}:${currMinutes}`; // get current time formatted

//API DATA
  const [timeEntries, setTimeEntries] = useState([]);

//FORM 
  const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
  const localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, 10);
  const initialFormDataEntries = { date: localISOTime, start_time: currTime.toString(), end_time:'', project: '', notes: '', billed: false, in_progress: false}
  const [formDataEntries, setFormDataEntries] = useState(initialFormDataEntries);
  const [showEntryModal, setShowEntryModal] = useState(false);
  const [editingEntry, setEditingEntry] = useState(null);
  const [formDataProjects, setFormDataProjects] = useState({project_name: '', client: ''});

//SELECTED WEEK 
  const first = currDate.getDate() - currDate.getDay() + 1 ; // First day is the day of the month - the day of the week
  const last = first + 6; // last day is the first day + 6
  const firstDayOfWeek = new Date(currDate.setDate(first));
  const lastDayOfWeek = new Date(currDate.setDate(last));
  const [selectedWeekStart, setSelectedWeekStart] = useState(firstDayOfWeek)
  const [selectedWeekEnd, setSelectedWeekEnd] = useState(lastDayOfWeek)

//FILTER 
  const [selectedClient, setSelectedClient] = useState('')
  const [clientFilterHasCleared, setClientFilterHasCleared] = useState(false)

//TOTAL HOURS
  const [totalUnbilledHours, setTotalUnbilledHours] = useState('')




//SORT 
  const [sortParams, setSortParams] = useState({orderby: 'date', order: 'DESC'})

//TIMER




/* ==============
  FETCH TIME ENTRIES
  =============*/

  useEffect(() => {
    fetchTimeEntries()
  }, [selectedClient, sortParams]);
  const fetchTimeEntries = async () => {
    const params = `&orderby=${sortParams.orderby}&order=${sortParams.order}`
      api
          .get(`/wp-json/projectman/v1/time_entries?clientid=${(selectedClient != '') ? selectedClient : ''}${params}`)
          .then((response) => {
           //  console.log('response',response.data)
            setTimeEntries(response.data)
          })
          .catch((err) => {
              console.log(err.message);
          });
  }





/* ==============
  CLIENT FILTER
  =============*/

  const handleChangeFilterClients = (e) => {
    setSelectedClient(e)
  }

  const handleClearClientFilter = () => {
    setSelectedClient('')
    setClientFilterHasCleared(!clientFilterHasCleared)
  }


/* ==============
  FORM SUBMIT ENTRIES
  =============*/


  useEffect(() => {
    if (formDataEntries.in_progress && !editingEntry) {
      handleSubmitEntry(null)      
    }else {
      return
    }
  }, [formDataEntries.in_progress]);


  const handleSubmitEntry = async (e) => {
    if (e !== null) {e.preventDefault()};
    const indexOfProject =  props.projects.findIndex(obj => obj.ID === formDataEntries.project)
  //  return console.log('formDataEntries', formDataEntries)

    if (!formDataEntries.date) return;
    const entryData = {
      status: 'publish',
      title: props.projects[indexOfProject].project_name,
      date: new Date(formDataEntries.date).toISOString(),
      acf: {
        start_time: formDataEntries.start_time,
        end_time: formDataEntries.end_time,
        in_progress: formDataEntries.in_progress,
        notes: formDataEntries.notes,
        project: [formDataEntries.project],
        billed: formDataEntries.billed
      }
    };

    if (editingEntry) {
      api
          .put(`/wp-json/wp/v2/time_entries/${editingEntry.ID}`, entryData)
          .then((response) => {
            fetchTimeEntries()
            setFormDataEntries(initialFormDataEntries)
            handleModalVisibility()
           })
          .catch((err) => {
              console.log(err.message);
              if (err.status === 400) {
                navigate('/login')
              }
          });
    }
    else if (!editingEntry) {
      api
          .post('/wp-json/wp/v2/time_entries', entryData)
          .then((response) => {
            fetchTimeEntries()
            setFormDataEntries(initialFormDataEntries)
            handleModalVisibility()
           })
          .catch((err) => {
              console.log(err.message);
              if (err.status === 400) {
                navigate('/login')
              }
          });
    }
  }
  

/* ==============
  EDIT ENTRIES
  =============*/
  
  const handleEdit = (entry) => {
    setEditingEntry(entry);
    setFormDataEntries({
      date: entry.date,
      project: entry.project[0].ID,
      start_time: entry.start_time,
      end_time: entry.end_time,
      in_progress: entry.in_progress,
      notes: entry.notes
    });
    setShowEntryModal(true);
  };


 /* ==============
  DELETE ENTRIES
  =============*/

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this entry?')) return;
    api
      .delete(`/wp-json/wp/v2/time_entries/${id}`)
      .then((response) => {
        fetchTimeEntries()
        setFormDataEntries(initialFormDataEntries)
       })
      .catch((err) => {
          console.log(err.message);
          if (err.status === 400) {
            navigate('/login')
          }
    });
  };




/* ==============
  FORM SUBMIT PROJECT
  =============*/




  const handleSubmitProject = async (e) => {
    e.preventDefault();
    if (!formDataProjects.project_name) return;
    const entryData = {
      status: 'publish',
      title: formDataProjects.project_name,
      acf: {
        client: formDataProjects.client
      }
    };
   //return console.log('entryData', entryData)

   try {
      if (!editingEntry) {
        const response = await fetch(`${API_URL}/wp/v2/projects`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("token")}`
           },
          body: JSON.stringify(entryData)
        })
        if (response.status == 201){
            props.fetchProjects()
            setFormDataProjects({project_name: '', client: ''})
        }
        }else if (editingEntry) {
        const response = await fetch(`${API_URL}/wp/v2/projects/${editingEntry.ID}`, {
          method: 'PUT',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("token")}`
           },
          body: JSON.stringify(entryData)
        })
        if (response.status == 200){
            props.fetchProjects()
            setFormDataProjects({project_name: '', client: ''})
        }
      }
    } catch (error) {
      console.error('Error saving project:', error);
      alert('Failed to save projects. Make sure the server is running.');
    }
  };
  



 /* ==============
  CHECK BILLING 
  =============*/
  
  const handleCheckBilled = async (entry) => {
    console.log(entry)
    const entryData = {
      acf: {
        billed: !entry.billed,
        project: [entry.project[0].ID]
      }
    };

   try {
        const response = await fetch(`${API_URL}/wp/v2/time_entries/${entry.ID}`, {
          method: 'PUT',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("token")}`
           },
          body: JSON.stringify(entryData)
        })
        if (response.status == 200){
            fetchTimeEntries()
        }
    } catch (error) {
      console.error('Error saving entry:', error);
      alert('Failed to save entry. Make sure the server is running.');
    }    
  }


 /* ==============
  MODAL
  =============*/
  
  const handleModalVisibility = () => {
    setShowEntryModal(!showEntryModal);
    setEditingEntry(null);
    setFormDataEntries(initialFormDataEntries);
  };
  


 /* ==============
  CLICK WEEK
  =============*/
  
  const handleClickWeek = (dir) => {
    const isNext = (dir == 'next') ? true : false
    const isPrev = (dir == 'prev') ? true : false
    const newStartDate = new Date(selectedWeekStart)
    const newEndDate = new Date(selectedWeekEnd)
    newStartDate.setDate( (isNext) ? selectedWeekStart.getDate() + 7 : selectedWeekStart.getDate() - 7)
    newEndDate.setDate((isNext) ? selectedWeekEnd.getDate() + 7 : selectedWeekEnd.getDate() - 7)
    setSelectedWeekStart(newStartDate);
    setSelectedWeekEnd(newEndDate);
  }

  const handleClickToday = () => {
    setSelectedWeekStart(firstDayOfWeek);
    setSelectedWeekEnd(lastDayOfWeek);
  
  }
  



 /* ==============
  HANDLE SORT
  =============*/


  const handleClickSort = (e, val) => {
    let newOrder = ''
    if (sortParams.order == 'ASC') {
      newOrder = 'DESC'
    }
    if (sortParams.order == 'DESC') {
      newOrder = 'ASC'
    }
    e.preventDefault()
    console.log('handleClickSort val', val)
    setSortParams({orderby: val, order: newOrder})
  }



 /* ==============
  HANDLE TIMER
  =============*/

  const handleStartTimer = () =>{
    setFormDataEntries({...formDataEntries, in_progress: true})
  }

  const handleStopTimer = () =>{
    setFormDataEntries({...formDataEntries, in_progress: false, end_time: currTime.toString()})
  }






 /* ==============
  CALCULATORS
  =============*/
  
  const calculateHours = (startTime, endTime) => {
    const [sh, sm] = startTime.split(':');
    const start = +sh + +sm / 60;    

    const [eh, em] = endTime.split(':');
    const end = +eh + +em / 60;    

    return (end - start).toFixed(2)
  }


  useEffect(() => {
    calculateTotalUnbilledHours()
  }, [timeEntries]);

  const calculateTotalUnbilledHours = () => {
    let total = 0
    timeEntries.map( (entry) => {
      if (!entry.billed) {
        const hours = calculateHours(entry.start_time, entry.end_time) 
        total += Number(hours)
      }
    })
    setTotalUnbilledHours(total)
    console.log('total', total)

  }


  const convert24To12Hour = (timeString) => {  
    // Step 1: Validate input  
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;  
    if (!timeRegex.test(timeString)) {  
      throw new Error('Invalid 24-hour time format. Use HH:MM:SS (e.g., "18:00:00").');  
    }  
   
    // Step 2: Split into hours, minutes, seconds  
    const [hours24, minutes, seconds] = timeString.split(':');  
   
    // Step 3: Convert hours to 12-hour format  
    const hours12 = parseInt(hours24, 10) % 12 || 12;  
   
    // Step 4: Determine AM/PM  
    const period = parseInt(hours24, 10) < 12 ? ' am' : ' pm';  
   
    // Step 5: Format output (no seconds, no leading zeros)  
    return `${hours12}:${minutes}${period}`;  
  }  



 /* ==============
  RENDER IT!
  =============*/
  

  return (

    <>  
          <h1 className="mb-6 text-3xl font-bold">Timesheet</h1>



          <div className="mb-6 ">
            <button
              onClick={handleModalVisibility}
              className="text-gray-100 bg-gray-700 hover:bg-gray-700/70 rounded-full px-4 py-2 transition-all"
              title="Add entry"
            ><Plus className="inline w-3 h-3 mr-2 text-gray-100" />
               Add Entry
            </button>
          </div>

{/* FILTER PROJECTS ======  
                <div className="mb-3  ">
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    Filter by Project
                  </label>
                  <div className="flex gap-2 w-80">
                      <SelectClientsProjects name="clients_projects" label="Select Project" array={props.clientsProjects} filterHasCleared={filterHasCleared} editingEntry={''} handleChangeSelect={(e) => handleChangeFilterProjects(e)}/>
                      { selectedProject  && 
                        <button className="font-semibold flex items-center text-xs rounded bg-black/10 px-2" onClick={handleClearFilter}><CircleX className="inline-block w-4 h-4" /></button> 
                      }
                    </div>
                </div>
*/}

{/* FILTER BY CLIENT ======  */}
          <div className="flex items-center mb-3">
                  <div className="flex gap-2 w-80">
                      <SelectClients name="clients_projects" label="Filter by Client" array={props.clients} filterHasCleared={clientFilterHasCleared} editingEntry={''} handleChangeSelect={(id) => setSelectedClient(id)}/>
                      { selectedClient  && 
                        <button className="font-semibold flex items-center text-xs rounded bg-black/10 px-2" onClick={handleClearClientFilter}><CircleX className="inline-block w-4 h-4" /></button> 
                      }
                  </div>
              {selectedClient &&
                <div className="ml-8">
                  Total Unbilled Hours: <span className="font-bold">{totalUnbilledHours}</span>
                </div>
              }
          </div>




{/* TIME ENTRIES ======  */}
        <div className="mb-6 py-2 bg-white rounded-2xl">
          {timeEntries.length == 0 && 'No Entries.' }

          {timeEntries.map((entry, index) => 
              <div key={`empty-${entry.ID}`} className="border-b last:border-0 border-stone-300 text-sm">
                <div className="p-2 grid grid-cols-12 gap-4 items-center">
                  <div className="col-span-1">{new Date(entry.date + 'T00:00:00').toLocaleDateString()}</div>
                  <div className="col-span-6">
                      <div className="inline"> {entry.notes} </div>
                      <span style={{ background: entry.client.color }} className="opacity-80 text-xs text-white px-2 py-1 mx-2">
                        <span className="opacity-80">{entry.client.client_name}</span>
                      </span> 
                      <span className="text-xs">
                        [{entry.project[0].post_title}]
                      </span>
                  </div>
                  <div className="col-span-1 text-xs">{convert24To12Hour(entry.start_time)}</div>
                  <div className="col-span-1 text-xs">{ (entry.in_progress) ? <div className='flex justify-center'><LoaderCircle className='w-6 h-6 animate-spin' /></div> : convert24To12Hour(entry.end_time)}</div>
                  <div className="col-span-1 font-bold">{(entry.in_progress) ? '—' : calculateHours(entry.start_time, entry.end_time)}</div>
                  <div className="col-span-1"><input type="checkbox" name="billed" defaultChecked={entry.billed} defaultValue={entry.billed} onClick={() => handleCheckBilled(entry)} /></div>
                  <div className="col-span-1">
                    <button className="mr-2" onClick={() => handleEdit(entry)}><Edit className="w-3 h-3" /></button>
                    <button className="mr-2" onClick={() => handleDelete(entry.ID)}><Trash2 className="w-3 h-3" /></button>
                  </div>
                </div>
              </div>

          )}
        </div>



{/* MODAL ======  */}
        {showEntryModal && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-2xl font-bold text-gray-800">
                  {editingEntry ? 'Edit Entry' : 'Add Entry'}
                </h3>
                <button
                  onClick={handleModalVisibility}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

      {/* FORM ENTRIES======  */}
            <form  onSubmit={handleSubmitEntry}>
                {/* TASK======  */}
                <div className="mb-3">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Task
                </label>
                <input
                  value={formDataEntries.notes}
                  onChange={(e) => setFormDataEntries({ ...formDataEntries, notes: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  placeholder="Add notes about this activity..."
                />
              </div>
              
                {/* DATE======  */}
                <div className="mb-3">
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    Date
                  </label>
                  <input className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent" 
                    type="date" 
                    name="date" 
                    max={`${currYear}-${currMonth.toString().padStart(2, 0)}-${currDay.toString().padStart(2, 0)}`}
                    value={formDataEntries.date}
                    onChange={(e) => setFormDataEntries({ ...formDataEntries, date: e.target.value })}
                  />                
                </div>

                {/* PROJECT======  */}
                <div className="mb-3">
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    Project
                  </label>
                    {/*<SelectProjects name="project" label="Select Project" array={props.projects} editingEntry={editingEntry} handleChangeSelect={(e) => setFormDataEntries({ ...formDataEntries, project: e })}/> */}
                    <SelectClientsProjects name="clients_projects" label="Select Project" array={props.clientsProjects} editingEntry={editingEntry} handleChangeSelect={(e) => setFormDataEntries({ ...formDataEntries, project: e })}/>

                </div>


                {/* START TIMER======  */}
                {!formDataEntries.in_progress && editingEntry === null &&
                  <div className="mb-3">
                      <button disabled={!formDataEntries.project} className="w-full bg-purple-600 hover:bg-purple-700 disabled:bg-slate-200 cursor-pointer text-white font-semibold p-3 rounded-lg transition-all flex items-center justify-center gap-2"
                          onClick={handleStartTimer}>
                          <Clock />
                          Start Timer
                      </button>
                  </div>

                  }

                {formDataEntries.in_progress && editingEntry !== null &&
                  <div className="mb-3">
                      <div className="w-full bg-purple-600 hover:bg-purple-700 disabled:bg-slate-200 cursor-pointer text-white font-semibold p-3 rounded-lg transition-all flex items-center justify-center gap-2"
                          onClick={handleStopTimer}>
                          <div className='flex justify-center'><LoaderCircle className='w-6 h-6 animate-spin' /></div>
                          Stop Timer
                      </div>
                  </div>

                }

                {!formDataEntries.in_progress && editingEntry === null &&
                      <div className="mb-3 text-center">
                        -- OR --
                      </div>
                }

                {/* START TIME======  */}

                {!formDataEntries.in_progress &&
                  <>
                    <div className="mb-3">
                      <label className="block text-sm font-semibold text-gray-700 mb-1">
                        Start Time
                      </label>
                      <input
                        type="time"
                        step="60"
                        required
                        value={formDataEntries.start_time}
                        onChange={(e) => setFormDataEntries({ ...formDataEntries, start_time: e.target.value })}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                      />
                    </div>


                  {/* END TIME======  */}
                  <div className="mb-3">
                    <label className="block text-sm font-semibold text-gray-700 mb-1">
                      End Time
                    </label>
                    <input
                      type="time"
                      step="60"
                      required
                      value={formDataEntries.end_time}
                      onChange={(e) => setFormDataEntries({ ...formDataEntries, end_time: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    />
                  </div>

                  {/* SUBMIT======  */}
                  <div className="mb-3">
                  <button
                    type="submit"
                    disabled={formDataEntries.end_time === '' || formDataEntries.project === ''}
                    className="disabled:bg-slate-200 bg-purple-600 hover:bg-purple-700 text-white font-semibold p-3 rounded-lg transition-all flex items-center justify-center gap-2"
                  >Submit
                  </button>
                </div>
              </>
            }
            </form>

            </div>
          </div>
        )}


  </>
  );
}
